import { meshComponent } from './Mesh.js';
import { props, createGeometry } from '../geometries/LatheGeometry.js';

export default meshComponent('Lathe', props, createGeometry);
